module.exports = __webpack_public_path__ + "h5-static/img/logo.7c582d87.png";